module.exports = __webpack_public_path__ + "statics/img/banner3.ee8ce784.jpg";